var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"select absolute z-10",on:{"click":function($event){return _vm.$emit('select', _vm.item)}}},[_c('span',{staticClass:"material-icons"},[_vm._v("\n        "+_vm._s(_vm.item.isAdded ? "check_circle" : "radio_button_unchecked")+"\n    ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }